module.exports = __webpack_public_path__ + "img/shape_circle.da4557a.png";